export default __webpack_public_path__ + "static/media/07.1f947b3b.jpg";